import mutations from './mutations';
import actions from './actions';

export default {
    namespaced: true,
    state(){
        return {
            messages: [],
            loading: true,   
        };
    },
    mutations,
    actions,
   
}
